
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './global.css'
import AdminHome from './Admin/container/Home';
import Dashboard from './Admin/container/Dashboard/index';
import Media from './Admin/container/Media/index';
import DefaultValue from "./Admin/container/DefaultValue/index";
import DefaultValueYearWise from "./Admin/container/Defaultyearwisevalue/index"
import GeneralSettings from "./Admin/container/GeneralSetting/index"
import SocialSettings from "./Admin/container/SocialSetting/index"
import Newsletter from './Admin/container/Newsletter';
import { ToastContainer } from 'react-toastify';
import Newsblogs from './Admin/container/Newsblogs';
import AddNewBlog from './Admin/container/Newsblogs/add-new-blog';
import AddBlogsCategory from './Admin/container/Newsblogs/add-categories';
import 'react-toastify/dist/ReactToastify.css';
import AddBlogsTags from './Admin/container/Newsblogs/add-tags';
import AdminFaq from './Admin/container/Faq';
import FooterSection from './Admin/container/Appearance/footer';
import AddNewPages from './Admin/container/Pages/add-new-page';
import AllPages from './Admin/container/Pages/all-pages';
import Customer from './Admin/container/Customer';
import CustomerDetail from './Admin/container/Customer/customerdetail'
import ProtectedRoute from './Admin/component/Services/ProtectedRoute';
import DefaultStrategy from './Admin/container/DefaultValue/DefaultStrategy';
function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Router>
        <Routes>
        <Route exact path='/' activeClassName="active" element={<AdminHome />} />
          <Route exact path='/csadmin/dashboard' activeClassName="active"  element={<ProtectedRoute element={<Dashboard />} />} />
          <Route exact path='/csadmin/media' activeClassName="active"  element={<ProtectedRoute element={<Media />} />} />
          <Route exact path='/csadmin/customer' activeClassName="active"  element={<ProtectedRoute element={<Customer />} />} />
          <Route exact path='/csadmin/customer/:id' activeClassName="active" element={<ProtectedRoute element={<CustomerDetail />} />}/>
          <Route exact path='/csadmin/add-new-faq' activeClassName="active"  element={<ProtectedRoute element={<AdminFaq />} />}/>
          <Route exact path='/csadmin/news-blogs' activeClassName="active" element={<ProtectedRoute element={<Newsblogs />} />}/>
          <Route exact path='/csadmin/add-new-blogs' activeClassName="active" element={<ProtectedRoute element={<AddNewBlog />} />} />
          <Route exact path='/csadmin/add-new-pages' activeClassName="active"  element={<ProtectedRoute element={<AddNewPages />} />}/>
          <Route exact path='/csadmin/all-pages' activeClassName="active"  element={<ProtectedRoute element={<AllPages />} />}/>
          <Route exact path='/csadmin/add-new-blogs/:slug' activeClassName="active"  element={<ProtectedRoute element={<AddNewBlog />} />}/>
          <Route exact path='/csadmin/add-new-pages/:slug' activeClassName="active"  element={<ProtectedRoute element={<AddNewPages />} />}/>
          <Route exact path='/csadmin/defaultvalue' activeClassName="active" element={<ProtectedRoute element={<DefaultValue />} />} />
          <Route exact path='/csadmin/defaultvalueyearwise' activeClassName="active" element={<ProtectedRoute element={<DefaultValueYearWise />} />}/>
          <Route exact path='/csadmin/defaultstrategy' activeClassName="active" element={<ProtectedRoute element={<DefaultStrategy />} />}/>
          <Route exact path='/csadmin/general-settings' activeClassName="active" element={<ProtectedRoute element={<GeneralSettings />} />}/>
          <Route exact path='/csadmin/newsletter' activeClassName="active" element={<ProtectedRoute element={<Newsletter />} />}/>
          <Route exact path='/csadmin/social-settings' activeClassName="active" element={<ProtectedRoute element={<SocialSettings />} />}/>
          <Route exact path='/csadmin/news-blogs/categories' activeClassName="active" element={<ProtectedRoute element={<AddBlogsCategory />} />}/>
          <Route exact path='/csadmin/news-blogs/tags' activeClassName="active" element={<ProtectedRoute element={<AddBlogsTags />} />}/>
          <Route exact path='/csadmin/appearance/footer' activeClassName="active" element={<ProtectedRoute element={<FooterSection />} />}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
